import { Button, Card, Checkbox, Form, message, Select,Table } from "antd";
import { UserApiService } from "features/users/api/user-api.service";
import { useCreateEventAgentRole } from "features/users/use-cases/create-event-role";
import { useCreateUserAgentRoleBYId } from "features/users/use-cases/create-setRoleAgentId";
import { useEffect,useState } from "react";
import { capitalizeFirst } from "routes/utils";

export const PermissionView = ({ userPermissionData, id, userData, data, EventRefetch, initial }: any) => {
  const { mutate } = useCreateUserAgentRoleBYId();
  const { mutate: AgentRole } = useCreateEventAgentRole();

  // useCreateUserAgentRoleBYId
  const [form] = Form.useForm();
  const getPermissionKeys = (data2: any[]) => {
    const first = data2?.find((x: any) => x.permissions);

    return first ? Object.keys(first.permissions) : [];
  };

  const [permissionKeys, setPermissionKeys] = useState<string[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [headerCheck, setHeaderCheck] = useState<any>({});
  const [expandedRowKeys, setExpandedRowKeys] = useState<any[]>([]);

  const groupMenuData = (list: any[]) => {
    const parents = list.filter((item) => item.parentKey === null);
    const children = list.filter((item) => item.parentKey !== null);

    return parents.map((parent) => ({
      ...parent,
      tableRowKey: parent.menuId,
      isParent: true,
      permissions: parent.permissions || {},

      children: children
        .filter((child) => child.parentKey === parent.key)
        .map((child) => ({
          ...child,
          tableRowKey: child.menuId,
          isChild: true,
        })),
    }));
  };

  useEffect(() => {
    if (userPermissionData) {
      const keys = getPermissionKeys(userPermissionData);
      setPermissionKeys(keys);

      const headers: any = {};
      keys.forEach((k) => (headers[k] = false));

      setHeaderCheck(headers);

      setTableData(groupMenuData(userPermissionData));
    }
  }, [userPermissionData]);

  useEffect(() => {
    if (tableData.length === 0) return;

    const newHeaderCheck: any = {};
    permissionKeys.forEach((key) => {
      const allChecked = tableData.every((parent) =>
        parent.children?.every((child: any) => child.permissions[key])
      );
      newHeaderCheck[key] = allChecked;
    });
    setHeaderCheck(newHeaderCheck);
  }, [tableData, permissionKeys]);

  // Parent & Child Checkbox
  const handleRowCheck = (rowKey: number, field: string, checked: boolean) => {
    setTableData((prev) =>
      prev.map((parent) => {
        // If parent row clicked
        if (parent.tableRowKey === rowKey && parent.isParent) {
          return {
            ...parent,
            permissions: { ...parent.permissions, [field]: checked },
            children: parent.children?.map((child: any) => ({
              ...child,
              permissions: { ...child.permissions, [field]: checked },
            })),
          };
        }

        // Child row click
        return {
          ...parent,
          children: parent.children?.map((child: any) =>
            child.tableRowKey === rowKey
              ? { ...child, permissions: { ...child.permissions, [field]: checked } }
              : child
          ),
        };
      })
    );
  };

  // Header checkbox
  const handleHeaderCheck = (field: string) => {
    const allChecked = tableData.every((parent) =>
      parent.children?.every((child: any) => child.permissions[field])
    );
    const newValue = !allChecked;

    setHeaderCheck((prev: any) => ({ ...prev, [field]: newValue }));

    setTableData((prev) =>
      prev.map((parent) => ({
        ...parent,
        permissions: { ...parent.permissions, [field]: newValue }, // parent added
        children: parent.children?.map((child: any) => ({
          ...child,
          permissions: { ...child.permissions, [field]: newValue },
        })),
      }))
    );
  };

  // Grant All
  //   const handleGrantAll = () => {
  //     const newTableData = tableData.map((parent) => ({
  //       ...parent,
  //       permissions: permissionKeys.reduce((acc: any, key) => {
  //         acc[key] = true;

  //         return acc;
  //       }, {}),
  //       children: parent.children?.map((child: any) => ({
  //         ...child,
  //         permissions: permissionKeys.reduce((acc: any, key) => {
  //           acc[key] = true;

  //           return acc;
  //         }, {}),
  //       })),
  //     }));

  //     setTableData(newTableData);

  //     const header: any = {};
  //     permissionKeys.forEach((key) => (header[key] = true));
  //     setHeaderCheck(header);

  //     const rolePermission = newTableData.flatMap((parent) => [
  //       {
  //         key: parent.key,
  //         permissions: parent.permissions,
  //       },
  //       ...parent.children.map((child: any) => ({
  //         key: child.key,
  //         permissions: child.permissions,
  //       })),
  //     ]);
  //     console.log(rolePermission,"rolepersmission");

  //     mutate(
  //       { userId: id, rolePermission } as any,
  //       {
  //         onSuccess: () => message.success("All permissions granted successfully"),
  //         onError: () => message.error("Failed to grant permissions"),
  //       }
  //     );
  //   };

  //   const mapPermissions = (permissions: any) => {
  //   const { update, ...rest } = permissions;
  //   return {
  //     ...rest,
  //     edit: update, // ✅ API expects edit
  //   };
  // };
  const handleGrantAll = () => {
    const newTableData = tableData.map((parent) => ({
      ...parent,
      permissions: permissionKeys.reduce((acc: any, key) => {
        acc[key] = true;
        
return acc;
      }, {}),
      children: parent.children?.map((child: any) => ({
        ...child,
        permissions: permissionKeys.reduce((acc: any, key) => {
          acc[key] = true;
          
return acc;
        }, {}),
      })),
    }));

    setTableData(newTableData);

    const header: any = {};
    permissionKeys.forEach((key) => (header[key] = true));
    setHeaderCheck(header);

    // ✅ REMOVE update, ADD edit ONLY
    const rolePermission = newTableData.flatMap((parent) => {
      const { update1, ...parentPerms } = parent.permissions;

      return [
        {
          key: parent.key,
          permissions: {
            ...parentPerms,
            edit: true,
          },
        },
        ...(parent.children ?? []).map((child: any) => {
          const { update, ...childPerms } = child.permissions;

          return {
            key: child.key,
            permissions: {
              ...childPerms,
              edit: true,
            },
          };
        }),
      ];
    });

    mutate(
      { userId: id, rolePermission } as any,
      {
        onSuccess: () =>
          message.success("All permissions granted successfully"),
        onError: () =>
          message.error("Failed to grant permissions"),
      }
    );
  };


  // Save privileges
  // const handlePrivilege = () => {
  //   const rolePermission = tableData.flatMap((parent) => [
  //     {
  //       key: parent.key,
  //       permissions: parent.permissions,
  //     },
  //     ...parent.children.map((child: any) => ({
  //       key: child.key,
  //       permissions: child.permissions,
  //     })),
  //   ]);

  //   mutate(
  //     { userId: id, rolePermission } as any,
  //     {
  //       onSuccess: () => message.success("Privilege updated successfully"),
  //       onError: () => message.error("Failed to update privileges"),
  //     }
  //   );
  // };
  const handlePrivilege = () => {
    const rolePermission = tableData.flatMap((parent) => [
      {
        key: parent.key,
        permissions: {
          ...parent.permissions,
          edit: parent.permissions.update, // ✅ convert
          update: undefined,               // ❌ remove update
        },
      },
      ...(parent.children ?? []).map((child: any) => ({
        key: child.key,
        permissions: {
          ...child.permissions,
          edit: child.permissions.update, // ✅ convert
          update: undefined,              // ❌ remove update
        },
      })),
    ]);

    mutate(
      { userId: id, rolePermission } as any,
      {
        onSuccess: () => message.success("Privilege updated successfully"),
        onError: () => message.error("Failed to update privileges"),
      }
    );
  };

  // Revoke all
  const handleRevokeAll = () => {
  const newTableData = tableData.map((parent) => ({
    ...parent,
    permissions: permissionKeys.reduce((acc: any, key) => {
      acc[key] = false;
      
return acc;
    }, {}),
    children: parent.children?.map((child: any) => ({
      ...child,
      permissions: permissionKeys.reduce((acc: any, key) => {
        acc[key] = false;
        
return acc;
      }, {}),
    })),
  }));

  setTableData(newTableData);

  const header: any = {};
  permissionKeys.forEach((key) => (header[key] = false));
  setHeaderCheck(header);

  const rolePermission = newTableData.flatMap((parent) => [
    {
      key: parent.key,
      permissions: {
        ...parent.permissions,
        edit: parent.permissions.update, // ✅ convert update → edit
      },
    },
    ...(parent.children || []).map((child: any) => ({
      key: child.key,
      permissions: {
        ...child.permissions,
        edit: child.permissions.update, // ✅ convert update → edit
      },
    })),
  ]);

  // ❌ Remove update key completely
  rolePermission.forEach((item: any) => {
    delete item.permissions.update;
  });

  mutate(
    { userId: id, rolePermission } as any,
    {
      onSuccess: () => {
        message.success("All permissions revoked successfully");
        initial(); // ✅ call after success
      },
      onError: () => {
        message.error("Failed to revoke permissions");
      },
    }
  );
};


  useEffect(() => {
    const keys = tableData
      .filter((i) => i.children && i.children.length)
      .map((i) => i.tableRowKey);
    setExpandedRowKeys(keys);
  }, [tableData]);

  const permissionColumn = (field: string) => ({
    title: (
      <Checkbox checked={headerCheck[field]} onChange={() => handleHeaderCheck(field)}
        disabled={field === "add" || field === "enable" || field === "print"}
        className="rol_check"
      >
        {/* {field.toUpperCase()} */}
        {/* {capitalizeFirst(field)} */}
        {
          field === "print"
            ? "Print / Export"
            : field === "enable"
              ? "Enable / Disable"
              : capitalizeFirst(field)
        }
      </Checkbox>
    ),
    key: field,
    render: (_: any, record: any) => {
      const isCoupon = record.title === "Coupon";

      const allowedPages = [
        "Transactions",
        "Group Registration",
        "Participant List",
        "Invoice List",
      ];

      return (
        <Checkbox
          className="rol_check"
          disabled={
            // ADD → same as coupon
            (!isCoupon && field === "add") ||

            // PRINT → enabled only for allowed pages
            (!allowedPages.includes(record.title) && field === "print") ||
            ([
              "Event Management",
              "Event List",
              "Coupon"
            ].includes(record.title) && field === "delete") ||
            // Your original Enable logic → keep disabled
            (!isCoupon && field === "enable") ||
            // ENABLE → keep same as original coupon logic
            (!isCoupon && field === "enable")
          }
          checked={record.permissions?.[field]}
          onChange={(e) =>
            handleRowCheck(record.tableRowKey, field, e.target.checked)
          }
        />
      );
    }


  });
  const initialAcess = async (params?: any) => {
    try {
      await UserApiService().getRoleAgentDetailEventAccess(
        params || { AgentId: userData?.user_id, Status: '', CategoryId: '', EventName: '', page: 1, size: 10 } as any
      );
    } catch (error: any) {
      message.error(error.message || "Something went wrong");
    }
  };
  const handleChange = (value: any) => {
    const payload = {
      agentId: id,
      roleId: value
    }
    AgentRole(payload, {
      onSuccess: (data1: any) => {
        if (data?.ResponseStatus == 2) {
          message.error(data1?.ResponseMessage)
        } else {
          message.success(data1.ResponseMessage)
        }
        initialAcess()
        initial()
        EventRefetch()
      }
    })
  }
  const columns: any = [
    {
      title: "Pages",
      dataIndex: "title",
      key: "title",
      width: 250,
      render: (text: any, record: any) =>
        record.isParent ? <b>{record.title}</b> : <span style={{ paddingLeft: 30 }}>{record.title}</span>,
    },
    ...permissionKeys .filter((perm) => (perm !== "delete" ))
    .map((key) => permissionColumn(key)),

  ];
  useEffect(() => {
    if (userData?.role) {
      form.setFieldsValue({
        role: userData.role,
      });
    }
  }, [userData]);

  return (
    <Card style={{ borderRadius: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", marginBottom: '20px' }}>
        <Form layout="vertical" form={form}>
          <Form.Item name="role" label="Role" style={{ marginBottom: 0 }}>
            <Select
              placeholder="--Select Role--"
              style={{ width: "150%" }}
              onChange={handleChange}
              options={data?.items?.map((item: any) => ({
                label: item.role_name,
                value: item.id,
              }))}
            />
          </Form.Item>

        </Form>
        <div style={{ display: "flex", gap: 10 }}>
          <Button type="primary" onClick={handlePrivilege}>Save Privileges</Button>
          <Button onClick={handleGrantAll}>Grant All</Button>
          <Button danger onClick={handleRevokeAll}>Revoke</Button>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        className="setrole_table"
        rowKey="tableRowKey"
        expandable={{
          expandedRowKeys,
          onExpand: (expanded, record) => {
            setExpandedRowKeys((prev) =>
              expanded
                ? [...prev, record.tableRowKey]
                : prev.filter((k) => k !== record.tableRowKey)
            );
          },
          childrenColumnName: "children",
        }}
      />
    </Card>
  );
};
